export default "/assets/website/images/certificate.png?4649d2f4a29de3b3a7574415a4f63d5d";